import type { CSSObject } from '@emotion/react'
import { colors } from 'settings/colors'

const baseCell: CSSObject = {
  border: `1px solid ${colors.grey200}`,
  padding: 10,
}

const baseHeaderCell: CSSObject = {
  ...baseCell,
  backgroundColor: colors.grey200,
  color: colors.midnight,
  textAlign: 'center',
  padding: 12,
}

export const icsTableStyles = {
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  } as CSSObject,

  headerCell: baseHeaderCell,

  headerCellSmall: {
    ...baseHeaderCell,
    padding: 8,
    fontSize: 14,
  } as CSSObject,

  bodyCell: {
    ...baseCell,
    textAlign: 'center',
  } as CSSObject,

  bodyCellLeft: {
    ...baseCell,
    textAlign: 'left',
  } as CSSObject,

  bodyCellBold: {
    ...baseCell,
    textAlign: 'center',
    fontWeight: 'bold',
  } as CSSObject,

  bodyCellHighlight: {
    ...baseCell,
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: colors.subtleBackground,
  } as CSSObject,

  bodyCellData: {
    ...baseCell,
    textAlign: 'center',
    backgroundColor: colors.grey50,
  } as CSSObject,

  bodyCellRain: {
    ...baseCell,
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: colors.rainLight,
  } as CSSObject,
}

export const getAlternatingRowStyle = (index: number, subtle = false): CSSObject => {
  if (index % 2 !== 0) return { backgroundColor: colors.white }

  return { backgroundColor: subtle ? colors.grey50 : colors.subtleBackground }
}
